module.exports = __webpack_public_path__ + "static/media/stepper-curate.4e7a2459.svg";